import React, { useEffect, useState } from "react";
import Profilesidebar from "../components/Element/Profilesidebar";
import WorkPrefrencesContainer from "../containers/WorkPrefrencesContainer";
import WorkPrefences from "./WorkPrefences";
import { isMobileOrLaptop } from "../services/CheckDevice";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";
import { connect } from "react-redux";
import constants from "../constants";
const KeyInformationDocument = (props) => {
  // Check Device - Start
  const [borderFile, setBorderFile] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [checkDevice, setCheckDevice] = useState("Mobile");
  const {
    cnd_key_information_document_folder,
    cnd_key_information_document_file,
  } = props.userData;

  const kidDocument =
    cnd_key_information_document_folder && cnd_key_information_document_file
      ? constants.IMAGE_URL +
        cnd_key_information_document_folder +
        cnd_key_information_document_file
      : "";

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);

  useEffect(() => {
    if (iframeLoaded) {
      const checkRender = setInterval(() => {
        const iframe = document.getElementById("pdf-frame");
        if (iframe?.contentDocument?.body?.children?.length > 0) {
          setBorderFile(true);
          clearInterval(checkRender);
        }
      }, 100); // check every 100ms

      return () => clearInterval(checkRender);
    }
  }, [iframeLoaded]);

  // Check Device - End
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice == "Mobile" ? (
                  <ProfileSideBarMobile page="key-information-document" />
                ) : (
                  <Profilesidebar page="key-information-document" />
                )}

                <div className="col-xl-9 col-lg-8 m-b30">
                  <div className="job-bx submit-resume mb-5 border">
                    <div className="job-bx-title clearfix">
                      <h6 className="font-weight-700 pull-left text-uppercase">
                        Key Information Document(KID)
                      </h6>
                    </div>
                    {kidDocument && (
                      <>
                        {!iframeLoaded && <div className="loader"></div>}

                        <iframe
                          id="pdf-frame"
                          src={kidDocument}
                          onLoad={() => setIframeLoaded(true)}
                          style={{
                            border: iframeLoaded ? "solid 1px black" : "none",
                          }}
                          width="100%"
                          height="600px"
                        />
                        <a
                          href="/sign-contract"
                          className="site-button listingnextbtn mt-3"
                        >
                          Next
                        </a>
                        <br />
                        <br />
                        <br />
                        <br />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userProfile.userData,
  };
};

export default connect(mapStateToProps)(KeyInformationDocument);
